import { PostProcessorModule, TOptions } from "i18next";

export const formatter: PostProcessorModule = {
  name: "formatter",
  process: (
    value: string,
    _key: string | string[],
    options: {
      values: (number | string)[];
    } & TOptions,
  ) => {
    (options.values ?? []).forEach((v, i) => {
      value = value.replaceAll(`%${i + 1}`, `${v}`);
    });

    return value.replaceAll("\\n", "\n").replaceAll("\\r", "\r");
  },
  type: "postProcessor",
};
